import React, { useEffect, useMemo, useState } from "react"
import { useSelector } from "react-redux";
import classes from './QuestionText.module.css'

const QuestionText = ({ index, question, setQuestion }) => {

    const { texts } = useSelector(state => state.translate);
    const textSuggestions = useMemo(() => ['howSuccessfulYou', 'wasTheLessonDifficult', 'wasTheTaskDifficultForYou', 'wasTheLessonFun'], []);
    const [showAlert, setShowAlert] = useState();
    const [lockBeforeId, setLockBeforeId] = useState(false)

    const hundleChange = (event) => {
        if ((!lockBeforeId)) {
            setLockBeforeId(true)
            setQuestion({ ...question, text: event.target.value })
        }
    }

    const debounce = (func, delay) => {
        let debounceTimer;
        return function () {
            const context = this;
            const args = arguments;
            clearTimeout(debounceTimer);
            debounceTimer =
                setTimeout(() => func.apply(context, args), delay);
        }
    }
    let optimisedHandleChange = debounce(hundleChange, 700);


    const changeReadyInput = (value) => {
        document.getElementById("questionInput").value = value;
        setQuestion({ ...question, text: value })
    }

    useEffect(() => {
        question?.type && setShowAlert(false)
        question?.id && setLockBeforeId(false)
    }, [question, index])

    return (
        <div className={showAlert ? classes.NoType : null} onClick={() => !question?.type && setShowAlert(true)}>
            <div className={classes.Title}>{texts.formulateReflectionQuestion}</div>
            <div className={classes.FormulateQuestion}>
                <textarea
                    className={classes.Input}
                    readOnly={!question?.type}
                    placeholder={texts.writeQuestionPlaceholder}
                    onChange={optimisedHandleChange}
                    defaultValue={question?.text}
                    key={index}
                    id="questionInput"
                />
                <div className={classes.Suggestions}>
                    {textSuggestions.map(text =>
                        <div key={text} className={`${classes.Suggestion} ${texts[text] === question?.text && classes.CurrentSuggestion}`}
                            onClick={() => { question?.type && changeReadyInput(texts[text]) }}>{texts[text]}</div>
                    )}
                </div>
            </div>
            <div className={classes.TypeAlert}>{texts.typeAlertReflection}</div>
        </div>
    )
}

export default QuestionText;